import { httpClient } from "@utils";
import {
	ResolveLimit,
	ResolveLimitRequest,
	ResolveResponse,
	ResolveUserLimitDE,
} from "@api-types";
import { GamingLimitIncreaseConsentLog } from "@api-types/account-settings/GamingLimitIncreaseConsentLog";
import { FindResultDto } from "@api-types/FindResultDto";
import { ApiRequestContextData, ContextOptions } from "@utils/api-config/types";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";

export class GamingLimitsApiService {
	static baseUrl(context: ApiRequestContextData): string {
		return `${WEBPACK_BASE_ADDRESS}${context?.agencyKey}/gaming-limits`;
	}

	static consentLogsBaseUrl(): string {
		return `${WEBPACK_BASE_ADDRESS}platform/gaming-limit-increase-consent-logs`;
	}

	static getRequestHeaders = (context: ApiRequestContextData) => {
		const appHeaders = getApplicationRequestHeaders(context);

		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static resolveGamingLimit(
		options: ContextOptions,
		resolveUserLimit: ResolveLimit
	): Promise<ResolveResponse> {
		const context = getApiRequestContext(options);

		const url = `${this.baseUrl(context)}/resolve`;
		return httpClient.post(
			url,
			JSON.stringify(resolveUserLimit),
			this.getRequestHeaders(context)
		);
	}

	static resolveDepositLimitWithLoss(
		options: ContextOptions,
		resolveUserLimit: ResolveUserLimitDE
	): Promise<ResolveResponse> {
		const context = getApiRequestContext(options);

		const url = `${this.baseUrl(context)}/resolve/de`;
		return httpClient.post(
			url,
			JSON.stringify(resolveUserLimit),
			this.getRequestHeaders(context)
		);
	}

	static withdrawConsent(
		options: ContextOptions,
		gamingLimitId: string
	): Promise<FindResultDto<GamingLimitIncreaseConsentLog>> {
		const context = getApiRequestContext(options);

		const url = `${this.consentLogsBaseUrl()}/consent/withdraw/${gamingLimitId}`;
		return httpClient.put(url, null, this.getRequestHeaders(context));
	}

	static getLastConsent(
		options: ContextOptions,
		limitId: string
	): Promise<FindResultDto<GamingLimitIncreaseConsentLog>> {
		const context = getApiRequestContext(options);

		const url = `${this.consentLogsBaseUrl()}/consent/last-consent/${limitId}`;
		return httpClient.get(url, this.getRequestHeaders(context));
	}

	static resolveGamingLimitRequest(
		options: ContextOptions,
		gamingLimitRequest: ResolveLimitRequest
	): Promise<ResolveResponse> {
		const context = getApiRequestContext(options);
		const url = `${this.baseUrl(context)}/resolve-request`;
		return httpClient.post(
			url,
			JSON.stringify(gamingLimitRequest),
			this.getRequestHeaders(context)
		);
	}
}
